import { Grid, Segment } from "semantic-ui-react";
import SubscriptionTotals from "pages/SubscriptionProducts/SubscriptionTotals";
import { useSelector } from "react-redux";
import { MathUtils } from "utils";
import { DateTimeUtils } from "dyl-components";

const NextInvoice = ({ quote, shouldNotDisplayPriceChanges, cartItems = [] }) => {
    const nextInvoice = useSelector(state => Object.keys(state.order.order?.next_invoice || {}).length ? state.order.order?.next_invoice : state.subscription.next_invoice);
    const fund_type = useSelector(state => state.order.order?.account?.fund_type);

    const isEvaluationAccount = ["demo","trial"].includes(fund_type);
    const { subscriptions: products } = useSelector((state) => ({
        subscriptions: state.subscription.current_products?.map((item) => ({
            quantity: item.quantity,
            key: `product-${item.product_id}-variation-${
                item.product_variation_id || 0
            }`,
        })) || [],
    }));
    const { grossTotal, subtotal, totalDiscount } = isEvaluationAccount
        ? {
            grossTotal: 0,
            totalDiscount: 0,
            totalTax: 0,
            totalFee: 0,
            subtotal: 0,
        }
        : cartItems
            .filter((item) => !Boolean(item.removed))
            .map(item => ({
                ...item,
                quantity: Number(item.quantity) + Number(products.find(
                    (currentRecurringProduct) => currentRecurringProduct.key ===
                        `product-${item.id}-variation-${item.variation_id || 0}`
                )?.quantity || 0) 
            }))
            .reduce(
                (a, item) => {
                    const productDetails = quote.quote_summary.find(
                        (quoteItem) =>
                            quoteItem.product_id === item.id &&
                            quoteItem.product_variation_id === item.variation_id
                    );
                    const price_data = Object.keys(productDetails.price_data).length ? productDetails.price_data : null;
                    const price = (() => {
                        if (productDetails.dyl_product_name?.includes("_balance")) {
                            return item.amount || 0;
                        }
                        if (!price_data || shouldNotDisplayPriceChanges) {
                            return productDetails.item_price || 0;
                        }
                        const isOneTime =
                            !price_data?.model?.includes(
                                "recurring"
                            );
                        const pricingModel = price_data.model;
                        if (isOneTime) {
                            if (!pricingModel.includes("volume")) {
                                return pricingModel === "usage"
                                    ? price_data.price.price
                                    : price_data.price;
                            }
                            return (
                                price_data.price.find(
                                    (range) =>
                                        item.quantity >= range.start &&
                                        item.quantity <=
                                        (range.end || Number.POSITIVE_INFINITY)
                                )?.price || 0
                            );
                        }
                        if (!pricingModel.includes("volume")) {
                            return (
                                price_data.price[item.pricing_schedule]
                                    ?.price || 0
                            );
                        }
                        const frequency =
                            price_data.price[item.pricing_schedule]
                                ?.volumes || [];
                        return (
                            frequency.find(
                                (range) =>
                                    item.quantity >= range.start &&
                                    item.quantity <=
                                    (range.end || Number.POSITIVE_INFINITY)
                            )?.price || 0
                        );
                    })();
                    const {
                        totalTax,
                        totalFee,
                        grossTotal,
                        subtotal,
                        discountAmount,
                    } = MathUtils.calculateItemTotals({
                        price,
                        additional_price:
                            productDetails.product_additional_price || 0,
                        quantity: item.quantity || 0,
                        discount: item.discount || 0,
                        addons: productDetails.addon
                            ?.filter(
                                (addon) =>
                                    item.addons.includes(addon.id) && !addon.unlinked
                            )
                            .map((addon) => ({
                                price: addon.current_price || 0,
                            })) || [],
                        taxes: productDetails.tax?.map((tax) => ({
                            amount: tax.current_amount || tax.amount,
                            percent: tax.tax_fee_percent,
                        })) || [],
                        fees: productDetails.fee?.map((fee) => ({
                            amount: fee.current_amount || fee.amount,
                            percent: fee.tax_fee_percent,
                        })) || [],
                    });

                    return {
                        grossTotal: a.grossTotal + grossTotal,
                        totalDiscount: a.totalDiscount + discountAmount,
                        totalTax: a.totalTax + totalTax,
                        totalFee: a.totalFee + totalFee,
                        subtotal: a.subtotal + subtotal,
                    };
                },
                {
                    grossTotal: 0,
                    totalDiscount: 0,
                    totalTax: 0,
                    totalFee: 0,
                    subtotal: 0,
                }
            );

    return (
        Object.keys(nextInvoice).map(period => (
            <Grid.Column key={period}>
                <Segment>
                    <SubscriptionTotals
                        subtotal={subtotal}
                        total={grossTotal}
                        totalDiscount={totalDiscount}
                        totalFee={nextInvoice[period].fee || 0}
                        totalTax={nextInvoice[period].tax || 0}
                        label={nextInvoice[period].next_invoice_date ? DateTimeUtils.changeFormat(
                    DateTimeUtils.convertUnixTimeToDate(nextInvoice[period].next_invoice_date),
                    "",
                    DateTimeUtils.WORD_DATE_FORMAT
                ) : ""}
                    />
                </Segment>
            </Grid.Column>
        ))
    );
};

export default NextInvoice;
